module.exports = __webpack_public_path__ + "assets/img/thumb-ARUMALABS-2-Video.0ceeb2a2.jpg";